<template>
    <div class="grid gap-y-4 sm:gap-y-6">
        <div
            class="md:h-80 bg-gray rounded shadow overflow-hidden  p-4 lg:p-6 flex flex-col gap-y-4"
            v-for="item in Array.from(Array(count).keys())"
        >
            <div class="flex items-center flex-none gap-x-4">
                <div
                    class="h-12 w-12 flex-none rounded-full bg-no-repeat bg-cover bg-center skeleton"
                ></div>
                <div class="flex flex-col justify-center gap-y-2">
                    <div class="h-5 w-32 skeleton"></div>
                    <div class="h-4 w-16 skeleton"></div>
                </div>
                <div class="ml-auto h-5 w-32 skeleton"></div>
            </div>
            <div class="grid grid-cols-3 h-full bg-gray gap-x-4">
                <div
                    class="col-span-3 md:col-span-2 flex flex-col gap-y-4 sm:gap-y-6"
                >
                    <div
                        class="flex flex-col flex-auto justify-between gap-y-4"
                    >
                        <div class="flex-none">
                            <div class="h-5 w-1/2 skeleton"></div>
                        </div>
                        <div class="flex-auto skeleton"></div>
                        <div
                            class="md:hidden h-80 relative rounded overflow-hidden skeleton flex-none"
                        ></div>

                        <div
                            class="flex items-center space-x-12 flex-none h-5 w-32 skeleton"
                        ></div>
                    </div>
                </div>
                <div
                    class="h-full overflow-hidden relative hidden md:block skeleton"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    count: {
        default: 3,
        type: Number,
    },
});
</script>
